import type { Definition } from '@exodus/dependency-types';
import { fetchival } from '@exodus/fetch';

const createExchangeClient = () => ({
  fetchOrder: async (orderId) => {
    const url = `https://exchange.exodus.io/v3/order/${orderId}`;
    const response = await fetchival(url).get();
    if (response.status !== 'success') {
      throw new Error(`${url} request failed.`);
    }

    return response.data;
  },
});

const exchangeClientDefinition = {
  id: 'exchangeClient',
  type: 'module',
  factory: createExchangeClient,
  dependencies: [],
} as const satisfies Definition;

const exchangeClient = () => ({
  id: 'exchangeClient',
  definitions: [{ definition: exchangeClientDefinition }],
});

export default exchangeClient;
